export const CLIENT_TAG = 'Client'
export const USER = 'User'
export const USERS_TAG = 'Users'
export const STUDENT_STATUS_TAG = 'StudentStatus'
export const MEDICAL_EXAM_TAG = 'MedicalExam'
export const ROLES_TAG = 'RolesTag'
export const ORGANIZATION_TAG = 'OrganizationTag'
export const ORGANIZATION_UNIT_TAG = 'OrganizationUnitTag'
export const ORGANIZATION_UNIT_OPTIONS = 'OrganizationUnitOptions'
export const ORGANIZATION_UNIT_CONTACTS_TAG = 'OrganizationUnitContactsTag'
export const QUICK_SELECTS_TAG = 'QuickSelectsTag'
export const SEASON_TAG = 'Season'
export const LEAGUE_TAG = 'League'
export const LEAGUES_TAG = 'Leagues'
export const UNIT_ROLES_AND_PERMISSIONS_TAG = 'UnitRolesAndPermissionsTag'
export const ACCREDITATION_TAG = 'Accreditation'
export const SPONSORS_TAG = 'Sponsors'
export const SPORTS_TAG = 'Sports'
export const SPORT_TAG = 'Sport'
export const POSITION_TAG = 'Position'
export const FORMATION_TAG = 'Formation'
export const SEASONS_TAG = 'SeasonsTag'
export const EVENT_TAG = 'Event'
export const DISCIPLINE_TAG = 'Disciplines'
export const COMPETITION_TAG = 'Competition'
export const SINGLE_COMPETITION_TAG = 'SingleCompetition'
export const APPLICATION_COMPETITION_TAG = 'ApplicationCompetition'
export const FINISHED_COMPETITION_TAG = 'FinishedCompetition'
export const UPCOMING_COMPETITION_TAG = 'UpcomingCompetition'
export const COMPETITION_DOCUMENTS_TAG = 'CompetitionDocuments'
export const GENERAL_APPLICATION = 'GeneralApplication'
export const TEAM_MEMBERS_TAG = 'TeamMembers'
export const TEAMS_TAG = 'Teams'
export const PHASES_TAG = 'Phases'
export const GROUP_TAG = 'Group'
export const GROUP_MATCHES_TAG = 'GroupMatches'
export const COMPETITION_TABLE_STATS_TAG = 'CompetitionTableStats'
export const COMPETITION_GROUP_STATS_TAG = 'CompetitionGroupStats'
export const RACE_STATS_TAG = 'RaceStats'
export const RACES_TAG = 'Race'
export const CHILD_MATCHES_TAG = 'ChildMatches'
export const INDIVIDUAL_USER = 'IndividualUser'
export const MATCHES_TAG = 'Matches'
export const MATCH_TAG = 'Match'
export const RECREATIONS_TAG = 'Recreations'
export const RECREATION_TAG = 'Recreation'
export const RECREATION_SESSIONS_TAG = 'RecreationSessions'
export const RECREATION_SESSION_TAG = 'RecreationSession'
export const RECREATION_SESSION_INSTANCES_TAG = 'RecreationSessionInstances'
export const RECREATION_SESSION_INSTANCE_TAG = 'RecreationSessionInstance'
export const RECREATION_SESSION_ATTENDANCES_TAG = 'RecreationSessionAttendances'
export const RECREATION_LEVEL_ATTENDANCES_TAG = 'RecreationLevelAttendances'
export const RECREATION_SESSION_INSTANCES_ATTENDANCE_TAG =
    'RecreationSessionInstancesAttendance'
export const UNAPPLIED_RECREATION_SESSION_INSTANCES_TAG =
    'UnappliedRecreationSessionInstances'
export const RECREATION_INSTANCE_ATTENDANCE_OF_A_USER_TAG =
    'RecreationInstanceAttendanceOfAUser'
export const RECREATION_INSTANCE_ATTENDANCE_OF_A_RECREATION_TAG =
    'RecreationInstanceAttendanceOfARecreation'

// CMS tags
export const CMS_PUBLICATIONS_TAG = 'CmsPublications'
export const CMS_EVENTS_TAG = 'CmsEvents'
export const CMS_PAGES_TAG = 'CmsPages'
export const CMS_DOCUMENT_CATEGORIES_TAG = 'CmsDocumentCategories'
export const CMS_SETTINGS_TAG = 'CmsSettings'
export const CMS_PUBLICATION_CATEGORIES_TAG = 'CmsPublicationCategories'

// Fetch API (no auth) — used by entities/participant-stats
export const COMPETITOR_STATS_TAG = 'CompetitorStats'
export const PARTICIPANT_MATCHES_TAG = 'ParticipantMatches'
export const PARTICIPANT_RACES_TAG = 'ParticipantRaces'
export const MATCH_STATS_TAG = 'MatchStats'
